var _templateObject = _taggedTemplateLiteralLoose(['\n  content: "";\n  position: absolute;\n  width: 100%;\n  color: ', ';\n  bottom: -20px;\n  border-bottom: 4px solid;\n  visibility: ', ';\n'], ['\n  content: "";\n  position: absolute;\n  width: 100%;\n  color: ', ';\n  bottom: -20px;\n  border-bottom: 4px solid;\n  visibility: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  justify-content: center;\n  align-content: center;\n  size: 20px;\n  padding: 3px;\n'], ['\n  display: flex;\n  justify-content: center;\n  align-content: center;\n  size: 20px;\n  padding: 3px;\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  margin: auto;\n'], ['\n  margin: auto;\n']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n  cursor: pointer;\n  &:focus {\n    outline: 0;\n  }\n'], ['\n  cursor: pointer;\n  &:focus {\n    outline: 0;\n  }\n']),
    _templateObject5 = _taggedTemplateLiteralLoose(['\n  align-self: center;\n  margin-left: 15px;\n  & span {\n    margin: 0;\n    margin-right: 20px;\n  } \n'], ['\n  align-self: center;\n  margin-left: 15px;\n  & span {\n    margin: 0;\n    margin-right: 20px;\n  } \n']),
    _templateObject6 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  white-space: nowrap;\n  top: 60px;\n  background: white;\n  z-index: 1;\n  right: 0;\n  visibility: ', ';\n  box-shadow: 0 5px 10px 0 ', ';\n'], ['\n  position: absolute;\n  white-space: nowrap;\n  top: 60px;\n  background: white;\n  z-index: 1;\n  right: 0;\n  visibility: ', ';\n  box-shadow: 0 5px 10px 0 ', ';\n']),
    _templateObject7 = _taggedTemplateLiteralLoose(['\n  padding: 15px 30px;\n  color: ', ';\n  text-decoration: none;\n  font-size: 16px;\n  font-family: ', ';\n  font-weight: 600;\n  letter-spacing: -0.13px;\n  line-height: 24px;\n  background: transparent;\n  display: block;\n  height: inherit;\n  width: 100%;\n  white-space: nowrap;\n\n  :hover, .active {\n    border-left: 5px solid ', ';\n    padding-left: 25px;\n    text-decoration: none;\n    color: ', ';\n    font-family: ', ';\n    font-size: 16px;\n    font-weight: 600;\n    letter-spacing: -0.13px;\n    line-height: 24px;\n  }\n'], ['\n  padding: 15px 30px;\n  color: ', ';\n  text-decoration: none;\n  font-size: 16px;\n  font-family: ', ';\n  font-weight: 600;\n  letter-spacing: -0.13px;\n  line-height: 24px;\n  background: transparent;\n  display: block;\n  height: inherit;\n  width: 100%;\n  white-space: nowrap;\n\n  :hover, .active {\n    border-left: 5px solid ', ';\n    padding-left: 25px;\n    text-decoration: none;\n    color: ', ';\n    font-family: ', ';\n    font-size: 16px;\n    font-weight: 600;\n    letter-spacing: -0.13px;\n    line-height: 24px;\n  }\n']),
    _templateObject8 = _taggedTemplateLiteralLoose(['\n  ', ';\n'], ['\n  ', ';\n']),
    _templateObject9 = _taggedTemplateLiteralLoose(['\n  ', ';\n  cursor: pointer;\n'], ['\n  ', ';\n  cursor: pointer;\n']),
    _templateObject10 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  justify-content: flex-start;\n  align-content: center;\n'], ['\n  display: flex;\n  justify-content: flex-start;\n  align-content: center;\n']),
    _templateObject11 = _taggedTemplateLiteralLoose(['\n  font-family: ', ';\n  font-size: ', ';\n  font-weight: ', ';\n  color: ', ';\n  white-space: nowrap;\n  margin-bottom: 5px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  @media(max-width: 991px) {\n    font-size: 18px;\n    font-weight: bold;\n  }\n'], ['\n  font-family: ', ';\n  font-size: ', ';\n  font-weight: ', ';\n  color: ', ';\n  white-space: nowrap;\n  margin-bottom: 5px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  @media(max-width: 991px) {\n    font-size: 18px;\n    font-weight: bold;\n  }\n']),
    _templateObject12 = _taggedTemplateLiteralLoose(['\n    ', '\n    right: 0 !important;\n    left: auto !important;\n  '], ['\n    ', '\n    right: 0 !important;\n    left: auto !important;\n  ']),
    _templateObject13 = _taggedTemplateLiteralLoose(['\n  transform: translate3d(0px, 58px, 0px) !important;\n  &.dropdown-menu.show {\n    ', ';\n    border-radius: 0;\n    box-shadow: 0 5px 10px 0 ', ';\n    margin: 0;\n    padding: 0;\n  }\n  & div.dropdown-divider {\n    margin: 0;\n  }\n'], ['\n  transform: translate3d(0px, 58px, 0px) !important;\n  &.dropdown-menu.show {\n    ', ';\n    border-radius: 0;\n    box-shadow: 0 5px 10px 0 ', ';\n    margin: 0;\n    padding: 0;\n  }\n  & div.dropdown-divider {\n    margin: 0;\n  }\n']),
    _templateObject14 = _taggedTemplateLiteralLoose(['\n  padding: 10px 30px;\n'], ['\n  padding: 10px 30px;\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React, { Fragment } from 'react';
import styled, { css } from 'styled-components';
import { DropdownToggle as RSDropdownToggle, DropdownMenu as RSDropdownMenu, DropdownItem } from 'reactstrap';
import { gold, primaryShadow, primary, blueGrey } from '../../assets/colors';
import { Montserrat } from '../../assets/fonts';
import handleMailClick from '../HeaderMailModal/handleMailClick';
import { capitalize } from '../utils/string';

export var ActiveIndicator = styled.div(_templateObject, gold, function (props) {
  return props.visible && 'visible' || 'hidden';
});

export var MenuIconBox = styled.div(_templateObject2);

export var MenuIcon = styled.i.attrs(function (props) {
  return {
    className: 'fa fa-2x ' + (props.open ? 'fa-angle-up' : 'fa-angle-down') + ' text-white'
  };
})(_templateObject3);

export var DropdownToggle = styled(RSDropdownToggle)(_templateObject4);

export var SignedInBox = styled.div(_templateObject5);

export var DropDownBox = styled.div(_templateObject6, function (props) {
  return props.visible && 'visible' || 'hidden';
}, primaryShadow);

var ActionCss = css(_templateObject7, function (props) {
  return props.color;
}, Montserrat, gold, primary, Montserrat);
// This was a styled LINK but need router for that
export var Action = styled.a.attrs(function (props) {
  return {
    href: props.to
  };
})(_templateObject8, ActionCss);
export var EmailAction = styled.div(_templateObject9, ActionCss);

export var MemberActions = styled.div(_templateObject10);

export var MemberName = styled.div(_templateObject11, Montserrat, function (props) {
  return props.fs || '12px';
}, function (props) {
  return props.fw || 600;
}, function (props) {
  return props.color || 'white';
});

var getDropdownPosition = function getDropdownPosition(_ref) {
  var publicDropdown = _ref.publicDropdown;
  return css(_templateObject12, publicDropdown ? 'top: 15px !important;' : '');
};

var DropdownMenu = styled(RSDropdownMenu)(_templateObject13, getDropdownPosition, primaryShadow);
var UserInfoWrapper = styled.div(_templateObject14);

export var UserInfo = function UserInfo(_ref2) {
  var _ref2$me = _ref2.me,
      me = _ref2$me === undefined ? {} : _ref2$me;
  return me.id ? React.createElement(
    Fragment,
    null,
    React.createElement(
      UserInfoWrapper,
      null,
      React.createElement(
        MemberName,
        { color: primary, fs: '16px' },
        capitalize(me.firstName),
        ' ',
        capitalize(me.lastName)
      ),
      React.createElement(
        MemberName,
        { color: primary, fs: '14px', fw: '500', className: 'text-muted mb-0' },
        'ID: ',
        me.id
      )
    ),
    React.createElement(DropdownItem, { divider: true })
  ) : null;
};

export var DropDown = function DropDown(_ref3) {
  var options = _ref3.options,
      comp = _ref3.comp,
      modalToggle = _ref3.modalToggle,
      meEmailMigrationData = _ref3.meEmailMigrationData,
      setModalType = _ref3.setModalType,
      publicDropdown = _ref3.publicDropdown,
      me = _ref3.me;

  var LinkFrame = comp || Action;
  return React.createElement(
    DropdownMenu,
    { publicDropdown: publicDropdown },
    React.createElement(UserInfo, { me: me }),
    options && React.createElement(
      Fragment,
      null,
      options.map(function (_ref4) {
        var id = _ref4.id,
            to = _ref4.to,
            target = _ref4.target,
            _ref4$label = _ref4.label,
            label = _ref4$label === undefined ? '' : _ref4$label;
        return React.createElement(
          Fragment,
          { key: label },
          label.toLowerCase() === 'my email' ? React.createElement(
            EmailAction,
            { onClick: function onClick() {
                return handleMailClick({ meEmailMigrationData: meEmailMigrationData, setModalType: setModalType, setOpen: modalToggle });
              }, color: blueGrey },
            label
          ) : React.createElement(
            LinkFrame,
            { to: to, target: target, color: blueGrey },
            label
          ),
          React.createElement(DropdownItem, { divider: true })
        );
      })
    ),
    !publicDropdown && React.createElement(
      LinkFrame,
      { to: '/logout', color: blueGrey },
      'LOGOUT'
    )
  );
};